import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";
import { FlyCommonModule } from "fly-common/fly-common.module";
import * as module from "module";

import { CustomersService } from "../../garmin-account/customers.service";
import { AuthGuardService } from "../auth-guard.service";
import { DeviceDetailsModule } from "../device-details/device-details.module";
import { DevicesListModule } from "../devices-list/devices-list.module";
import { SharedModule } from "../shared/shared.module";
import { AircraftRoleService } from "../aircraft-role.service";
import { AircraftShareSettingsAddUserComponent } from "./aircraft-share-settings-add-user.component";
import { AircraftShareSettingsComponent } from "./aircraft-share-settings.component";
import { AircraftShareSettingsManageThirdPartiesComponent } from "./aircraft-share-settings-manage-third-parties.component";
import { AircraftShareSettingsManageUsersComponent } from "./aircraft-share-settings-manage-users.component";
import { AircraftShareSettingsPendingInviteRowComponent } from "./aircraft-share-settings-pending-invite-row.component";
import { AircraftShareSettingsRemoveUserComponent } from "./aircraft-share-settings-remove-user.component";
import {AircraftShareSettingsPendingInviteRemoveComponent} from "./aircraft-share-settings-pending-invite-remove.component";
import { AircraftShareSettingsThirdPartyRowComponent } from "./aircraft-share-settings-third-party-row.component";
import { AircraftShareSettingsUserRowComponent } from "./aircraft-share-settings-user-row.component";
import { AircraftSharingService } from "./aircraft-sharing.service";
import {AircraftShareSettingsEditPendingUserComponent} from "./aircraft-share-settings-edit-user-pending.component";
import {AircraftShareSettingsEditActiveUserComponent} from "./aircraft-share-settings-edit-user-active.component";

const routes: Routes = [
	{
		path: "aircraft",
		canActivateChild: [AuthGuardService],
		children: [
			{
				path: ":tail-number/share-settings",
				component: AircraftShareSettingsComponent,
			},
		],
	},
];

@NgModule({
	imports: [
		CommonModule,
		DeviceDetailsModule,
		DevicesListModule,
		FlyCommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule.forChild(routes),
		SharedModule
	],
	declarations: [
		AircraftShareSettingsAddUserComponent,
		AircraftShareSettingsEditPendingUserComponent,
		AircraftShareSettingsEditActiveUserComponent,
		AircraftShareSettingsComponent,
		AircraftShareSettingsManageThirdPartiesComponent,
		AircraftShareSettingsManageUsersComponent,
		AircraftShareSettingsPendingInviteRowComponent,
		AircraftShareSettingsPendingInviteRemoveComponent,
		AircraftShareSettingsRemoveUserComponent,
		AircraftShareSettingsThirdPartyRowComponent,
		AircraftShareSettingsUserRowComponent
	],
	exports: [
		RouterModule
	],
	providers: [
		AircraftRoleService,
		AircraftSharingService,
		CustomersService,
		{provide: "loggedInUserCustomerGuid", useValue: module.config().loggedInUserCustomerGuid},
		{provide: "v2AircraftRoleTypeId", useValue: module.config().v2AircraftRoleTypeId},
		{provide: "v2UserRoleUuid", useValue: module.config().v2UserRoleUuid},
		{provide: "v2UserLsqReceiveRoleUuid", useValue: module.config().v2UserLsqReceiveRoleUuid},
		{provide: "v2UserLsqTriggerRoleUuid", useValue: module.config().v2UserLsqTriggerRoleUuid},
		{provide: "herculesModelIds", useValue: module.config().herculesModelIds}
	]
})
export class AircraftShareSettingsModule {}
